<template>
  <!-- <div style="width: 100%;height: 100%; background-color:#eee;">
      <div style="display:inline-block;width: 20%;height: 100%; background-color:#eee; float: left;z-index: 0;">
        <v-data-table :headers="headers" :items="devices" item-key="id" :search="search" :footer-props="{
        'items-per-page-options': [10, 20, 30, 40, 50]
        }" :items-per-page="40" @click:row="onRowClick($event)" class="elevation-1">
      </v-data-table>
      </div> -->
  <!-- optionally define the sidebar content via HTML markup -->
  <div
    id="map4"
    style="
      display: inline-block;
      width: 100%;
      height: 100%;
      background-color: #eee;
    "
  >
    <div class="text-center">
      <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
        {{ snackText }}
        <v-btn text @click="snack = false">Close</v-btn>
      </v-snackbar>
      <v-dialog v-model="dialog" max-width="850px">
        <v-card>
          <v-card-text>
            <v-form v-model="valid">
              <v-container>
                <v-row>
                  <v-col cols="12" sm="6" md="4">
                    <v-menu
                      ref="menu1"
                      v-model="menu1"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      full-width
                      max-width="400px"
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="dateFormatted"
                          label="Train Date"
                          hint="DD/MM/YYYY format"
                          persistent-hint
                          required
                          :rules="dateRules"
                          prepend-icon="event"
                          @blur="
                            editedItem.train_date = parseDate(dateFormatted)
                          "
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="editedItem.train_date"
                        no-title
                        @input="menu1 = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field
                      v-model="editedItem.train_no"
                      label="Train No"
                      @input="queryTrain($event)"
                      :rules="trainNoRules"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="3">
                    <v-text-field
                      v-model="editedItem.train_no_text"
                      label="Train Name"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="6" md="3">
                    <v-text-field
                      v-model="editedItem.org"
                      label="ORG"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="3">
                    <masked-input
                      v-model="editedItem.dep"
                      label="DEP"
                      mask="11:11"
                      placeholder="Dep"
                      style="
                        font-size: 12pt;
                        padding: 13px;
                        border-bottom: 2px solid #4fc08d;
                        width: 75pt;
                      "
                    />
                  </v-col>
                  <v-col cols="12" sm="6" md="3">
                    <v-text-field
                      v-model="editedItem.dest"
                      label="DEST"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="3">
                    <masked-input
                      v-model="editedItem.arr"
                      label="Arr"
                      mask="11:11"
                      placeholder="Arr"
                      style="
                        font-size: 12pt;
                        padding: 13px;
                        border-bottom: 2px solid #4fc08d;
                        width: 75pt;
                      "
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="6" md="3">
                    <v-text-field
                      v-model="editedItem.pf"
                      label="PF No"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="3">
                    <v-text-field
                      v-model="editedItem.next_train_no"
                      label="Next Trian No"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </v-card-text>

          <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
            <v-btn color="blue darken-1" text @click="save" :disabled="!valid"
              >Save</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>

    <div id="sidebar" class="leaflet-sidebar collapsed">
      <!-- nav tabs -->
      <div class="leaflet-sidebar-tabs">
        <!-- top aligned tabs -->
        <ul role="tablist">
          <li>
            <a href="#home" role="tab"><i class="fa fa-bars active"></i></a>
          </li>
          <!-- <li><a href="#autopan" role="tab"><i class="fa fa-arrows"></i></a></li> -->
        </ul>

        <!-- bottom aligned tabs -->
        <!-- <ul role="tablist">
                    <li><a href="https://github.com/nickpeihl/leaflet-sidebar-v2"><i class="fa fa-github"></i></a></li>
                </ul> -->
      </div>

      <!-- panel content -->
      <div class="leaflet-sidebar-content">
        <div class="leaflet-sidebar-pane" id="home">
          <h1 class="leaflet-sidebar-header">
            Rake List
            <span class="leaflet-sidebar-close"
              ><i class="fa fa-caret-left"></i
            ></span>
          </h1>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
          <v-data-table
            :headers="headers"
            :items="devices"
            item-key="id"
            :search="search"
            :footer-props="{
              'items-per-page-options': [10, 20, 30, 40, 50, 120],
            }"
            :items-per-page="120"
            @click:row="onRowClick($event)"
            class="elevation-1"
          >
          </v-data-table>
        </div>

        <!-- <div class="leaflet-sidebar-pane" id="autopan">
                    <h1 class="leaflet-sidebar-header">
                        autopan
                        <span class="leaflet-sidebar-close"><i class="fa fa-caret-left"></i></span>
                    </h1>
                    <p>
                        <code>Leaflet.control.sidebar({ autopan: true })</code>
                        makes shure that the map center always stays visible.
                    </p>
                    <p>
                        The autopan behviour is responsive as well.
                        Try opening and closing the sidebar from this pane!
                    </p>
                </div>

                <div class="leaflet-sidebar-pane" id="messages">
                    <h1 class="leaflet-sidebar-header">Messages<span class="leaflet-sidebar-close"><i class="fa fa-caret-left"></i></span></h1>
                </div> -->
      </div>
    </div>
    <l-map
      ref="map3"
      :zoom="zoom"
      :center="center"
      :options="mapOptions"
      style="height: 100%; z-index: 0"
    >
      <l-tile-layer :url="url" />
    </l-map>
  </div>
</template>



<script>
import axios from "axios";
import moment from "moment";
import _ from "lodash";
import { L, latLng, icon } from "leaflet";
import { LMap, LTileLayer } from "vue2-leaflet";

import "leaflet/dist/leaflet.css";
import "leaflet-draw/dist/leaflet.draw.css";
import "leaflet-draw";
import "./../js/movingmarker.js";

import "leaflet-search/dist/leaflet-search.src.js";
import "leaflet-search/dist/leaflet-search.min.css";

import "./../js/leaflet-sidebar.js";
import "./../js/leaflet-sidebar.css";
import "leaflet-overpass-layer/dist/OverPassLayer.bundle.js";
import "leaflet-overpass-layer/dist/OverPassLayer.css";

import "leaflet-rotate/dist/leaflet-rotate-src.js";
import { SDAH_NH_SUB_SIG } from "./../data/sdah-nh-sub-sig.js";
import { SDAH_NH_MAIN_SIG } from "./../data/sdah-nh-main-sig.js";
import { NH_SDAH_SUB_SIG } from "./../data/nh-sdah-sub-sig.js";
import { NH_SDAH_MAIN_SIG } from "./../data/nh-sdah-main-sig.js";
import { NH_KNJ_SIG } from "./../data/nh-knj-sig.js";
import { KNJ_NH_SIG } from "./../data/knj-nh-sig.js";

import { KNJ_LGL_SIG } from "./../data/knj-lgl-sig.js";
import { LGL_KNJ_SIG } from "./../data/lgl-knj-sig.js";

import { RHA_GEDE_SIG } from "./../data/rha-gede-sig.js";
import { GEDE_RHA_SIG } from "./../data/gede-rha-sig.js";

import { DDJ_BT_SIG } from "./../data/ddj-bt-sig.js";
import { BT_DDJ_SIG } from "./../data/bt-ddj-sig.js";
import { BT_BNJ_SIG } from "./../data/bt-bnj-sig.js";
import { BT_HNB_SIG } from "./../data/bt-hnb-sig.js";

import { BNJ_BT_SIG } from "./../data/bnj-bt-sig.js";
import { HNB_BT_SIG } from "./../data/hnb-bt-sig.js";
//import { BT_DDJ_SIG } from './../data/bt-ddj-sig.js'

import { RHA_BNJ_SIG } from "./../data/rha-bnj-sig.js";
import { BNJ_RHA_SIG } from "./../data/bnj-rha-sig.js";

import { DDJ_DKAE_SIG } from "./../data/ddj-dkae-sig.js";
import { DKAE_DDJ_SIG } from "./../data/dkae-ddj-sig.js";
// south
//import { SDAH_BGB_SIG } from './../data/sdah-bgb-sig.js'
import { BGB_SDAH_SIG } from "./../data/bgb-sdah-sig.js";
import { CG_SPR_SIG } from "./../data/cg-spr-sig.js";
import { NAM_SPR_SIG } from "./../data/nam-spr-sig.js";
import { SPR_BLN_SIG } from "./../data/spr-bln-sig.js";
import { DH_BRP_SIG } from "./../data/dh-brp-sig.js";

import MaskedInput from "vue-masked-input";
import $ from "jquery";

import { sdah_routes } from "../geojsons/sdah_route.js";
import { sdahpf_routes } from "../geojsons/sdahpf_routes.js";

export default {
  name: "live_view_l",
  components: {
    LMap,
    LTileLayer,
    MaskedInput,
  },

  // For anyone who wants to save some time while looking for specific tile types:
  //
  // h = roads only
  // m = standard roadmap
  // p = terrain
  // r = somehow altered roadmap
  // s = satellite only
  // t = terrain only
  // y = hybrid
  data() {
    return {
      dialog: false,
      dateFormatted: moment().format("DD/MM/YYYY"),
      dateRules: [(v) => !!v || "Date is required"],
      trainNoRules: [(v) => !!v || "Train No is required"],
      valid: true,
      search: "",
      editedIndex: -1,
      editedItem: {
        train_date: moment().format("YYYY-MM-DD"),
        train_no: "",
        division: "",
        zone: "",
        train_no_text: "",
        org: "",
        dep: "",
        dest: "",
        arr: "",
        pf: "",
        next_train_no: "",
      },
      defaultItem: {
        train_date: moment().format("YYYY-MM-DD"),
        train_no: "",
        division: "",
        zone: "",
        train_no_text: "",
        org: "",
        dep: "",
        dest: "",
        arr: "",
        pf: "",
        next_train_no: "",
      },
      device_id: null,
      device_name: null,
      menu1: false,
      menu2: false,
      zoom: 11,
      maxZoom: 22,
      center: latLng(22.573768, 88.381173),
      // url: "http://www.google.cn/maps/vt?lyrs=s@189&gl=cn&x={x}&y={y}&z={z}",
      // attribution: 'google',
      // url: "http://www.google.cn/maps/vt?lyrs=y@189&gl=cn&x={x}&y={y}&z={z}",
      // url: "https://maps.wikimedia.org/osm-intl/{z}/{x}/{y}.png",
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution:
        '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
      // attribution: 'google',
      search: "",
      mapOptions: {
        zoomSnap: 1,
        minZoom: 10,
        maxBounds: [
          [29.033972, 70.192046],
          [6.3301302, 91.070748],
          // [26.132167, 85.801627],
          // [21.448266, 89.071288]
        ],
        rotate: true,
        touchRotate: true,
        rotateControl: {
          closeOnZeroBearing: false,
        },
        bearing: 135,
      },
      windowHeight: window.innerHeight,
      map: null,
      search: "",
      devices: [],
      signals_up: [],
      signals_dn: [],
      headers: [
        {
          text: "Srl",
          align: "left",
          sortable: true,
          value: "id",
        },
        {
          text: "Rake No",
          align: "left",
          sortable: true,
          value: "text",
        },
        {
          text: "Train No",
          value: "trainno",
        },
        {
          text: "Last Update",
          value: "timeFromNow",
        },
        {
          text: "Actions",
          value: "action",
          sortable: false,
        },
      ],
      emuIcon: window.L.icon({
        iconUrl: require("../assets/emu.png"),
        iconSize: [16, 26],
        iconAnchor: [10.5, 31],
        popupAnchor: [4, -25]
      }),
      wam4Icon: window.L.icon({
        iconUrl: require("../assets/wam4.png"),
        iconSize: [16, 26],
        iconAnchor: [10.5, 31],
        popupAnchor: [4, -25]
      }),
      dieselIcon: window.L.icon({
        iconUrl: require("../assets/diesel.png"),
        iconSize: [16, 26],
        iconAnchor: [10.5, 31],
        popupAnchor: [4, -25]
      }),
      tvanIcon: window.L.icon({
        iconUrl: require("../assets/tvan.png"),
        iconSize: [16, 26],
        iconAnchor: [10.5, 31],
        popupAnchor: [4, -25]
      }),
      carIcon: window.L.icon({
        iconUrl: require("../assets/car.png"),
        iconSize: [16, 26],
        iconAnchor: [10.5, 31],
        popupAnchor: [4, -25]
      }),
      artIcon: window.L.icon({
        iconUrl: require("../assets/art.png"),
        iconSize: [16, 26],
        iconAnchor: [10.5, 31],
        popupAnchor: [4, -25],
        className: "blinking",
      }),
      vbIcon: window.L.icon({
        iconUrl: require("../assets/vb.png"),
        iconSize: [32, 52],
        iconAnchor: [16, 52],
        popupAnchor: [4, -25],
        className: "blinking",
      }),
      psr10Icon: window.L.icon({
        iconUrl: require("../assets/10.png"),
        iconSize: [32, 32],
        iconAnchor: [32, 64],
        popupAnchor: [4, -25],
      }),
      psr15Icon: window.L.icon({
        iconUrl: require("../assets/15.png"),
        iconSize: [32, 32],
        iconAnchor: [16, 32],
        popupAnchor: [4, -25],
      }),
      psr20Icon: window.L.icon({
        iconUrl: require("../assets/20.png"),
        iconSize: [32, 32],
        iconAnchor: [16, 32],
        popupAnchor: [4, -25],
      }),
      psr30Icon: window.L.icon({
        iconUrl: require("../assets/30.png"),
        iconSize: [32, 32],
        iconAnchor: [16, 32],
        popupAnchor: [4, -25],
      }),
      psr45Icon: window.L.icon({
        iconUrl: require("../assets/45.png"),
        iconSize: [32, 32],
        iconAnchor: [16, 32],
        popupAnchor: [4, -25],
      }),
      psr50Icon: window.L.icon({
        iconUrl: require("../assets/50.png"),
        iconSize: [32, 32],
        iconAnchor: [16, 32],
        popupAnchor: [4, -25],
      }),
      psr65Icon: window.L.icon({
        iconUrl: require("../assets/65.png"),
        iconSize: [32, 32],
        iconAnchor: [16, 32],
        popupAnchor: [4, -25],
      }),
      psr75Icon: window.L.icon({
        iconUrl: require("../assets/75.png"),
        iconSize: [32, 32],
        iconAnchor: [16, 32],
        popupAnchor: [4, -25],
      }),
      nsOpenIcon: window.L.icon({
        iconUrl: require("../assets/ns_open.jpg"),
        iconSize: [20, 40],
        iconAnchor: [10, 40],
        popupAnchor: [4, -25],
      }),

      sigIcon: null,
      sigIcons: [],
      sigRedIcon: null,
      sigGreenIcon: null,
      sigYYIcon: null,
      sigYellowIcon: null,
      dnSigIcon: null,
      dnSigIcons: [],
      dnSigRedIcon: null,
      dnSigGreenIcon: null,
      dnSigYYIcon: null,
      dnSigYellowIcon: null,
      dnSigSections: {
        "SDAH-RHA": NH_KNJ_SIG,
        "SDAH-KNJ": NH_KNJ_SIG,
        "RHA-KNJ": NH_KNJ_SIG,
        "RHA-GEDE": NH_KNJ_SIG,
        RHA_GEDE_SIG,
        "SDAH-BT": DDJ_BT_SIG,
        "SDAH-BNJ": DDJ_BT_SIG,
        BT_BNJ_SIG,
        "SDAH-HNB": DDJ_BT_SIG,
        BT_HNB_SIG,
        "BT-HNB": DDJ_BT_SIG,
        BT_HNB_SIG,
        ALLUP: NH_KNJ_SIG.concat(
          RHA_GEDE_SIG,
          RHA_BNJ_SIG,
          DDJ_BT_SIG,
          BT_BNJ_SIG,
          BT_HNB_SIG,
          BGB_SDAH_SIG,
          CG_SPR_SIG,
          NAM_SPR_SIG,
          SPR_BLN_SIG,
          DH_BRP_SIG
        ),
        ALLDN: KNJ_NH_SIG.concat(
          GEDE_RHA_SIG,
          BNJ_RHA_SIG,
          BNJ_BT_SIG,
          HNB_BT_SIG,
          BT_DDJ_SIG
        ),
        ALL: NH_KNJ_SIG.concat(
          RHA_GEDE_SIG,
          RHA_BNJ_SIG,
          DDJ_BT_SIG,
          BT_BNJ_SIG,
          BT_HNB_SIG,
          KNJ_NH_SIG,
          GEDE_RHA_SIG,
          BNJ_RHA_SIG,
          BNJ_BT_SIG,
          HNB_BT_SIG,
          BT_DDJ_SIG
        ),
      },
      sdah_nh_sub: false,
      sdah_nh_main: false,
      min: 0,
      max: 150,
      range: [5, 130],
      selectRange: false,
      positions: [],
      socket: null,
      snack: false,
      snackColor: "",
      snackText: "",
    };
  },
  beforDestroy() {
    this.socket.close(1000);
  },
  mounted() {
    window.addEventListener("resize", () => {
      this.windowHeight = window.innerHeight;
    });
    this.zoom = localStorage.getItem("zoom")
      ? parseInt(localStorage.getItem("zoom"))
      : 11;

    this.center = localStorage.getItem("center_lat")
      ? latLng(
          localStorage.getItem("center_lat"),
          localStorage.getItem("center_lng")
        )
      : latLng(22.573768, 88.381173);

    // console.log(
    //   localStorage.getItem("zoom"),
    //   localStorage.getItem("center_lat")
    // );

    this.map = this.$refs.map3.mapObject;

    // window.L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
    //     attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    // }).addTo(this.map);

    // window.L.tileLayer('https://maps.wikimedia.org/osm-intl/{z}/{x}/{y}.png', {
    //     attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    // }).addTo(this.map);
    //     var searchCtrl = window.L.control.fuseSearch()
    // searchCtrl.addTo(this.map);
    // add a layer group, yet empty

    // h = roads only
    // m = standard roadmap
    // p = terrain
    // r = somehow altered roadmap
    // s = satellite only
    // t = terrain only
    // y = hybrid

    var railway = window.L.tileLayer(
      "http://{s}.tile.openrailwaymap.org/{z}/{x}/{y}.png",
      {
        attribution:
          '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
      }
    );
    var googleSateliteMap = window.L.tileLayer(
      "http://www.google.cn/maps/vt?lyrs=s@189&gl=cn&x={x}&y={y}&z={z}",
      {
        attribution: "google",
      }
    );
    var googleRoadMap = window.L.tileLayer(
      "http://www.google.cn/maps/vt?lyrs=m@189&gl=cn&x={x}&y={y}&z={z}",
      {
        attribution: "google",
      }
    );
    var googleHybrid = window.L.tileLayer(
      "http://www.google.cn/maps/vt?lyrs=h@189&gl=cn&x={x}&y={y}&z={z}",
      {
        attribution: "google",
      }
    );
    var zoomLevel = 14;
    var w = this.round(zoomLevel * 1.1, 0);
    var h = this.round(zoomLevel * 2.8, 0);
    this.createSigIcon(w, h);
    var baseLayers = {
      "Google Satelite": googleSateliteMap,
      "Google Road": googleRoadMap,
      "Google hybrid": googleHybrid,
      "Open Railway": railway,
    };

    //   var opl = new window.L.OverPassLayer({
    //     debug: true,
    //     endPoint: 'http://overpass.osm.rambler.ru/cgi/',
    //     query: 'way({{bbox}})["route"="railway"];out;',
    //     minZoomIndicatorOptions: {
    //         position: 'topright',
    //         minZoomMessage: 'Current zoom level: CURRENTZOOM - All data at level: MINZOOMLEVEL'
    //     }
    // });
    //   this.map.addLayer(opl);

    var sidebar = new window.L.control.sidebar({
      container: "sidebar",
    }).addTo(this.map);
    // .open('home');

    const drawnItems = new window.L.FeatureGroup();
    const dnSigLayer = new window.L.FeatureGroup();
    const upSigLayer = new window.L.FeatureGroup();
    const routesLayer = new window.L.FeatureGroup();
    var stationsJson = {
      type: "FeatureCollection",
      features: [],
    };
    axios.defaults.headers.common["Authorization"] =
      localStorage.getItem("jwtToken");

    window.L.geoJson(sdah_routes).addTo(routesLayer);
    routesLayer.addTo(this.map);
    // addGeoJson()

    const sdahPfRoutesLayer = new window.L.FeatureGroup();
    window.L.geoJson(sdahpf_routes, {
      onEachFeature: function (feature, layer) {
        if (feature.properties && feature.properties.pf) {
          //  console.log(feature.properties)
          layer
            .bindTooltip(feature.properties.pf, {
              permanent: true,
              direction: "center",
              opacity: 0.8,
              // offset: [-20, -15],
              pane: "overlayPane",
              className: "stn",
            })
            .openTooltip();
        }
      },
      style: function (feature) {
        switch (feature.properties.pf) {
          case "14":
            return { color: "red" };
          // case '3': return {color: "red"};
          // case '4':   return {color: "green"};
        }
      },
    }).addTo(sdahPfRoutesLayer);
    // sdahPfRoutesLayer.addTo(this.map);

    axios
      .get(`${process.env.VUE_APP_API_URL}/geofences/`)
      .then((responses) => {
        //      console.log(responses.data);
        _.forEach(responses.data, function (o) {
          var geometry = JSON.parse(o.area);
          stationsJson.features.push(geometry);
          geometry.properties.id = o.id;
          geometry.properties.type = o.description;
          var json = new window.L.GeoJSON(geometry, {
            style: {color: "#a70000"},
            pointToLayer: function (feature, latlng) {
              switch (feature.geometry.type) {
                case "Polygon":
                  //var ii = new L.Polygon(latlng)
                  //ii.addTo(drawnItems);
                  return window.L.polygon(latlng);
                case "LineString":
                  return window.L.polyline(latlng);
                case "Point":
                  return window.L.marker(latlng);
                default:
                  return;
              }
            },
            onEachFeature: function (feature, layer) {
              if (feature.properties && feature.properties.title) {
                //  console.log(feature.properties)
                if (feature.properties.type == "Station") {
                  layer
                    .bindTooltip(feature.properties.title, {
                      // permanent: true,
                      direction: "center",
                      opacity: 1.0,
                      offset: [-20, -15],
                      className: "stn",
                    })
                    // .openTooltip();
                } else if (feature.properties.type == "Junction") {
                  layer
                    .bindTooltip(feature.properties.title, {
                      permanent: true,
                      direction: "center",
                      opacity: 0.8,
                      offset: [20, -60],
                      className: "junction",
                    })
                    .openTooltip();
                } else {
                  layer
                    .bindTooltip(feature.properties.title, {
                      permanent: true,
                      direction: "center",
                      opacity: 0.8,
                      offset: [-50, 0],
                      className: "lc",
                    })
                    .openTooltip();
                }
              }
              layer.addTo(drawnItems);
            },
          });

          //          console.log(json)
        });
        // searchCtrl.indexFeatures(stationsJson, ['title']);
        // window.L.geoJson(stationsJson, {
        //     onEachFeature: function (feature, layer) {
        //         feature.layer = layer;
        //     }
        // });
      })
      .catch((e) => {
        console.log(e);
      });
    window.L.control
      .scale({
        position: "topright",
      })
      .addTo(this.map);

    const editableLayers = drawnItems.addTo(this.map);

    var searchControl = new window.L.Control.Search({
      layer: editableLayers,
      propertyName: "title",
      marker: false,
      moveToLocation: function (latlng, title, map) {
        //map.fitBounds( latlng.layer.getBounds() );
        //var zoom = map.getBoundsZoom(latlng.layer.getBounds());
        var zoom = 13;
        map.setView(latlng, zoom); // access the zoom
      },
    });
    this.map.addControl(searchControl);

    var markersLayer = new window.L.LayerGroup();
    var markersShuntLayer = new window.L.LayerGroup();
    var markersTVANLayer = new window.L.LayerGroup();
    var markersARTLayer = new window.L.LayerGroup();
    var markersCautionLayer = new window.L.LayerGroup();
    window.L.Control.textbox = window.L.Control.extend({
      onAdd: function (map) {
        var text = window.L.DomUtil.create("div");
        text.id = "info_text";
        text.innerHTML = "<span style='font-size:20px;color:red'>clock</span>";
        return text;
      },

      onRemove: function (map) {
        // Nothing to do here
      },
    });
    window.L.control.textbox = function (opts) {
      return new window.L.Control.textbox(opts);
    };
    window.L.control
      .textbox({
        position: "topright",
      })
      .addTo(this.map);

    this.startTime();
    axios.defaults.headers.common["Authorization"] =
      localStorage.getItem("jwtToken");

    axios
      .get(`${process.env.VUE_APP_API_URL}/device`)
      .then((response) => {
        //console.log(response.data)
        var that = this;
        var tooltipPopup;
        var markerGroup = markersLayer;
        response.data.forEach(function (d) {
          if (d.latitude) {
            var ic = that.emuIcon;
            var clname = "labelstyleemu_l";
            switch (d.category) {
              case "tram":
                ic = that.wam4Icon;
                clname = "labelstylewam4";
                markerGroup = markersShuntLayer;
                break;
              case "truck":
                ic = that.dieselIcon;
                clname = "labelstyledsl";
                markerGroup = markersShuntLayer;
                break;
              case "van":
                ic = that.tvanIcon;
                clname = "labelstyletvan";
                markerGroup = markersTVANLayer;
                break;
              case "crane":
                ic = that.artIcon;
                clname = "labelstyleart";
                markerGroup = markersTVANLayer;
                break;
              case "car":
                ic = that.carIcon;
                clname = "labelstylecar";
                markerGroup = markersLayer;
                break;
              case "bus":
                ic = that.vbIcon;
                clname = "labelstylecar";
                markerGroup = markersLayer;
                break;
              default:
                ic = that.emuIcon;
                clname = "labelstyleemu_l";
                markerGroup = markersLayer;
            }
            var m = window.L.Marker.movingMarker([[d.latitude, d.longitude]], {
              title: d.name,
              riseOnHover: true,
              zIndexOffset: 10000,
            })
              .setIcon(ic)
              .bindTooltip(d.name, {
                className: clname,
                permanent: true,
                opacity: 1.0,
                direction: "center",
              })
              .bindPopup(d.name,
                {
                  className: "labelstyleemu_l",
                  permanent: true,
                  opacity: 1.0,
                  direction: "center",
                  autoPanPadding: window.L.point(50, 50),
                }
              )
              .addTo(markerGroup)
              .on("contextmenu", function (e) {
                that.device_id = d.id;
                that.device_name = d.name;
                that.dialog = true;
              });
          }
          markersLayer.addTo(that.map);
          markersShuntLayer.addTo(that.map);
          markersTVANLayer.addTo(that.map);
          markersARTLayer.addTo(that.map);

          if (that.getLocalTime(d.lastupdate) > moment().add(-1, "hours")) {
            that.devices.push({
              id: d.id,
              loc: [d.latitude, d.longitude],
              text: d.name,
              title: d.name,
              trainno: "",
              train_dtl: "",
              timeFromNow: that.getTimeFromNow(d.lastupdate),
              formatedTime: that.getFormattedTime(d.lastUpdate),
              speed: "",
              mi: m,
              beacon: {},
            });
          }
        });
        // console.log(this.devices)
      })
      .catch((e) => {
        console.log(e);
      });

    axios
      .get(`${process.env.VUE_APP_API_URL}/cautions`)
      .then((response) => {
        //console.log(response.data)
        var that = this;
        var tooltipPopup;
        for (var i = 0; i < response.data.length; i++) {
          var d = response.data[i];
          if (d.lat) {
            var ic = that.psr10Icon;
            switch (d.name) {
              case "10":
                ic = that.psr10Icon;
                break;
              case "15":
                ic = that.psr15Icon;
                break;
              case "20":
                ic = that.psr20Icon;
                break;
              case "30":
                ic = that.psr30Icon;
                break;
              case "45":
                ic = that.psr45Icon;
                break;
              case "50":
                ic = that.psr50Icon;
                break;
              case "65":
                ic = that.psr65Icon;
                break;
              case "75":
                ic = that.psr75Icon;
                break;
              case "ns_open":
                ic = that.nsOpenIcon;
                break;
              default:
                ic = that.psr20Icon;
            }
            var m = window.L.marker([d.lat, d.lng], {
              title: d.name,
              riseOnHover: true,
            })
              .setIcon(ic)
              .bindPopup(d.lat + ", " + d.lng, {
                className: "labelstyleemu_l",
                permanent: true,
                opacity: 1.0,
                direction: "center",
              })
              .addTo(markersCautionLayer);
            // console.log(d)
            // m.on('dragend', (e) => {
            //   console.log(d)
            //   const data = {
            //         'id': d.id,
            //         'lat': e.target._latlng.lat,
            //         'lng': e.target._latlng.lng
            //         }
            //   axios.put(`${process.env.VUE_APP_API_URL}/cautions/`, data)
            //   .then(response => {
            //     console.log(response)
            //   })
            //   .catch(e => {
            //     console.log(e)

            //   })
            // })
          }
        }
        markersCautionLayer.addTo(that.map);
      })
      .catch((e) => {
        console.log(e);
      });

    axios.defaults.headers.common["Authorization"] =
      localStorage.getItem("jwtToken");
    axios
      .get(`${process.env.VUE_APP_API_URL}/geofences/signals/DN`)
      .then((response) => {
        if (response.data) {
          var sigJson = this.prepareSigGioJsonDB(response.data);
          var sigIconDn = this.dnSigRedIcon;
          this.showMarkers(sigJson, sigIconDn, this.signals_dn, dnSigLayer);
          // dnSigLayer.addTo(this.map);
        }
      })
      .catch((e) => {
        console.log(e);
      });

    axios.defaults.headers.common["Authorization"] =
      localStorage.getItem("jwtToken");
    axios
      .get(`${process.env.VUE_APP_API_URL}/geofences/signals/UP`)
      .then((response) => {
        if (response.data) {
          var sigJson = this.prepareSigGioJsonDB(response.data);
          var sigIconUp = this.sigRedIcon;
          this.showMarkers(sigJson, sigIconUp, this.signals_up, upSigLayer);
          // upSigLayer.addTo(this.map);
        }
      })
      .catch((e) => {
        console.log(e);
      });

    var overlayMaps = {
      Geofences: drawnItems,
      "Up Signals": upSigLayer,
      "DN Signals": dnSigLayer,
      "PSR and NS": markersCautionLayer,
      "EMU and MEMU": markersLayer,
      "Shunting Locos": markersShuntLayer,
      "Tower Van": markersTVANLayer,
      "ART and ARM": markersARTLayer,
      "Show Routes": routesLayer,
    };
    window.L.control
      .layers(baseLayers, overlayMaps, { position: "bottomleft" })
      .addTo(this.map);

    setInterval(() => {
      this.animateSig();
    }, 3000);

    this.map.on("click", function (e) {
      console.log(e.latlng.lat, e.latlng.lng);
    });
    this.map.on("zoomend", () => {
      var zoomLevel = this.map.getZoom();
      localStorage.setItem("zoom", this.map.getZoom());
      var tooltip = $(".leaflet-tooltip");
      var w = this.round(zoomLevel * 1.1, 0);
      var h = this.round(zoomLevel * 1.8, 0);
      var f = this.round(zoomLevel * 0.58, 0);
      this.createSigIcon(w, h);
      this.animateSig();
      //tooltip.css('font-size', f);
      console.log(zoomLevel);
    });
    this.map.on("moveend", () => {
      localStorage.setItem("center_lat", this.map.getCenter().lat);
      localStorage.setItem("center_lng", this.map.getCenter().lng);
      console.log(
        "moveend",
        localStorage.getItem("zoom"),
        localStorage.getItem("center_lat"),
        localStorage.getItem("center_lng")
      );
    });
  },
  created() {
    var ajax = function (method, url, callback) {
      var xhr = new XMLHttpRequest();
      xhr.withCredentials = true;
      xhr.open(method, url, true);
      xhr.onreadystatechange = function () {
        if (xhr.readyState == 4) {
          callback(JSON.parse(xhr.responseText));
        }
      };
      if (method == "POST") {
        xhr.setRequestHeader(
          "Content-type",
          "application/x-www-form-urlencoded"
        );
      }
      xhr.send();
    };
    this.socket = null;
    ajax("GET", `${process.env.VUE_APP_API_JAVA_URL}/api/server`, (server) => {
      var that = this;

      ajax(
        "POST",
        `${process.env.VUE_APP_API_JAVA_URL}/api/session?email=srdeeopsdah@gmail.com&password=sdah1234`,
        (user) => {
          if (that.socket == null || that.socket.readyState === 3) {
            that.socket = new WebSocket(
              `${process.env.VUE_APP_API_SOCKET_JAVA_URL}/api/socket`
            );
          }
          that.socket.onclose = function (event) {
            console.log("socket closed");
          };
          that.socket.onmessage = function (event) {
            var data = JSON.parse(event.data);
            if (data.positions) {
              var i = 0;
              for (i = 0; i < data.positions.length; i++) {
                var position = data.positions[i];
                // var beaconstr = position.attributes.io385;
                // var nearestBeacon;
                // var beacons;
                // if (beaconstr) {
                //   beacons = that.parseBeaconString(
                //     beaconstr,
                //     position.deviceTime
                //   );
                //   nearestBeacon = _.minBy(beacons, "distance");
                //   // console.log(beacons)
                // }
                var device = that.devices.find(function (device) {
                  return device.id === position.deviceId;
                });
                if (device && device.mi) {
                  // if (!that.devices[`${position.deviceId}`].mi) {
                  // var m = window.L.Marker.movingMarker([
                  //   [position.latitude, position.longitude]
                  // ]).
                  // setIcon(that.emuIcon).bindTooltip(that.getTimeFromNow(position.fixtime)).addTo(that.map);
                  // that.devices[`${position.deviceId}`].mi =  m
                  // }
                  // that.devices[`${position.deviceId}`].loc = {
                  //   lat: position.latitude,
                  //   lng: position.longitude
                  // },
                  //    that.devices[`${position.deviceId}`].timeFromNow = that.getTimeFromNow(position.fixtime)

                  device.speed = `${that.round(position.speed * 1.852, 0)} K/H`;
                  device.mi.moveTo(
                    [position.latitude, position.longitude],
                    10000
                  );
                  device.loc.latitude = position.latitude;
                  device.loc.longitude = position.longitude;
                  // if (nearestBeacon) {
                  //   device.beacon = nearestBeacon;
                  // }
                  // if (beacons) {
                  //   console.log(device.text, beacons);
                  // }
                }
              }
            }
            if (data.devices) {
              var i = 0;
              for (i = 0; i < data.devices.length; i++) {
                var serverDevice = data.devices[i];
                var device = that.devices.find(function (device) {
                  return device.id === serverDevice.id;
                });
                var popUpContent;
                if (device) {
                  device.timeFromNow = `${that.getTimeFromNow(
                    serverDevice.lastUpdate
                  )}`;
                  device.formatedTime = `${that.getFormattedTime(
                    serverDevice.lastUpdate
                  )}`;
                  // var updatedDevice = device

                  popUpContent =
                    
                  device.trainno;

                  var content;

                  if (
                    device.timeFromNow === "in a few seconds" ||
                    device.timeFromNow === "a few seconds ago"
                  ) {
                    content =
                      (device.trainno ? device.trainno : device.text) +
                      " " +
                      device.speed;
                  } else {
                    content =
                      (device.trainno ? device.trainno : device.text) +
                      " " +
                      device.speed;
                  }
                  if (device.mi) {
                    //    console.log(device)
                    device.mi.getTooltip().setContent(content);
                    device.mi.getPopup().setContent(popUpContent);
                    device.mi.openTooltip();
                  }
                }
              }
            }
          };
        }
      );
    });

    this.$options.sockets.onmessage = (data) => {
      //  console.log(data.data)
      var pdata = JSON.parse(data.data);
      //  console.log(this.$refs)

      var device = this.devices.find(function (device) {
        return device.id == pdata.deviceid;
      });

      if (pdata && device && device.mi) {
        // console.log(pdata)
        // if (pdata.lastupdate) {
        //   device.timeFromNow = `${this.getTimeFromNow(pdata.lastupdate)}`
        // }
        var content, popUpContent;
        if (pdata.trainno) {
          device.trainno = `${pdata.trainno}`;
          device.train_dtl = `${pdata.trainno} ${pdata.org} ${this.getShortTime(
            pdata.dep
          )}-${pdata.dest} ${this.getShortTime(pdata.arr)}`;
        }
        // if (pdata.latitude && !isNaN(pdata.latitude)) {
        //
        //   //  console.log(device.text,this.round(pdata.speed * 1.852,0))
        //   //    console.log(pdata.latitude,pdata.longitude)
        //   device.speed = `${this.round(pdata.speed * 1.852,0)} KMPH`
        //   device.mi.moveTo([pdata['latitude'], pdata['longitude']], 4000)
        //
        //
        // }
        popUpContent =
          "Train No: " +
          device.train_dtl +
          "<br>" +
          "Rake No: " +
          device.text +
          "<br>" +
          "Speed: " +
          device.speed +
          "<br>" +
          "Last Update: " +
          device.formatedTime;
    
        if (
          device.timeFromNow === "in a few seconds" ||
          device.timeFromNow === "a few seconds ago"
        ) {
          content =
            (device.trainno ? device.trainno : device.text) +
            " " +
            device.speed;
        } else {
          content =
            (device.trainno ? device.trainno : device.text) +
            " " +
            device.speed;
        }
        device.mi.getTooltip().setContent(content);
        device.mi.getPopup().setContent(popUpContent);
        device.mi.openTooltip();
      }
    };
  },
  methods: {
    createSigIcon(x, y) {
      this.sigRedIcon = window.L.icon({
        iconUrl: require("../assets/signal_red.png"),
        //	    shadowUrl: 'images/signal_post-shadow.png',

        iconSize: [x, y], // size of the icon
        //	    shadowSize:   [50, 64], // size of the shadow
        iconAnchor: [x, y], // point of the icon which will correspond to marker's location
        //	    shadowAnchor: [4, 62],  // the same for the shadow
        popupAnchor: [-3, -38], // point from which the popup should open relative to the iconAnchor
      });
      this.sigYellowIcon = window.L.icon({
        iconUrl: require("../assets/signal_yellow.png"),
        //	    shadowUrl: 'images/signal_post-shadow.png',

        iconSize: [x, y], // size of the icon
        //	    shadowSize:   [50, 64], // size of the shadow
        iconAnchor: [x, y], // point of the icon which will correspond to marker's location
        //	    shadowAnchor: [4, 62],  // the same for the shadow
        popupAnchor: [-3, -38], // point from which the popup should open relative to the iconAnchor
      });
      this.sigYYIcon = window.L.icon({
        iconUrl: require("../assets/signal_yy.png"),
        //	    shadowUrl: 'images/signal_post-shadow.png',

        iconSize: [x, y], // size of the icon
        //	    shadowSize:   [50, 64], // size of the shadow
        iconAnchor: [x, y], // point of the icon which will correspond to marker's location
        //	    shadowAnchor: [4, 62],  // the same for the shadow
        popupAnchor: [-3, -38], // point from which the popup should open relative to the iconAnchor
      });
      this.sigGreenIcon = window.L.icon({
        iconUrl: require("../assets/signal_green.png"),
        //	    shadowUrl: 'images/signal_post-shadow.png',

        iconSize: [x, y], // size of the icon
        //	    shadowSize:   [50, 64], // size of the shadow
        iconAnchor: [x, y], // point of the icon which will correspond to marker's location
        //	    shadowAnchor: [4, 62],  // the same for the shadow
        popupAnchor: [-3, -38], // point from which the popup should open relative to the iconAnchor
      });
      (this.dnSigIcon = window.L.icon({
        iconUrl: require("../assets/dn_sig.png"),
        //	    shadowUrl: 'images/signal_post-shadow.png',
        iconSize: [x, y], // size of the icon
        //	    shadowSize:   [50, 64], // size of the shadow
        iconAnchor: [x, y], // point of the icon which will correspond to marker's location
        //	    shadowAnchor: [4, 62],  // the same for the shadow
        popupAnchor: [-3, -38], // point from which the popup should open relative to the iconAnchor
      })),
        (this.dnSigRedIcon = window.L.icon({
          iconUrl: require("../assets/dn_sig_red.png"),
          //	    shadowUrl: 'images/dn_sig_post-shadow.png',

          iconSize: [x, y], // size of the icon
          //	    shadowSize:   [50, 64], // size of the shadow
          iconAnchor: [x, y], // point of the icon which will correspond to marker's location
          //	    shadowAnchor: [4, 62],  // the same for the shadow
          popupAnchor: [-3, -38], // point from which the popup should open relative to the iconAnchor
        }));
      this.dnSigYellowIcon = window.L.icon({
        iconUrl: require("../assets/dn_sig_yellow.png"),
        //	    shadowUrl: 'images/dn_sig_post-shadow.png',

        iconSize: [x, y], // size of the icon
        //	    shadowSize:   [50, 64], // size of the shadow
        iconAnchor: [x, y], // point of the icon which will correspond to marker's location
        //	    shadowAnchor: [4, 62],  // the same for the shadow
        popupAnchor: [-3, -38], // point from which the popup should open relative to the iconAnchor
      });
      this.dnSigYYIcon = window.L.icon({
        iconUrl: require("../assets/dn_sig_yy.png"),
        //	    shadowUrl: 'images/dn_sig_post-shadow.png',

        iconSize: [x, y], // size of the icon
        //	    shadowSize:   [50, 64], // size of the shadow
        iconAnchor: [x, y], // point of the icon which will correspond to marker's location
        //	    shadowAnchor: [4, 62],  // the same for the shadow
        popupAnchor: [-3, -38], // point from which the popup should open relative to the iconAnchor
      });
      this.dnSigGreenIcon = window.L.icon({
        iconUrl: require("../assets/dn_sig_green.png"),
        //	    shadowUrl: 'images/signal_post-shadow.png',

        iconSize: [x, y], // size of the icon
        //	    shadowSize:   [50, 64], // size of the shadow
        iconAnchor: [x, y], // point of the icon which will correspond to marker's location
        //	    shadowAnchor: [4, 62],  // the same for the shadow
        popupAnchor: [-3, -38], // point from which the popup should open relative to the iconAnchor
      });
    },
    animateSig() {
      this.sigIcons = [
        this.sigRedIcon,
        this.sigYellowIcon,
        this.sigYYIcon,
        this.sigGreenIcon,
      ];
      this.dnSigIcons = [
        this.dnSigRedIcon,
        this.dnSigYellowIcon,
        this.dnSigYYIcon,
        this.dnSigGreenIcon,
      ];
      var sn = 0;
      var si1 = 0;
      var si2 = 1;
      var si3 = 2;
      var si4 = 3;
      var sn = Math.floor(Math.random() * Math.floor(21));
      var si1 = Math.floor(Math.random() * Math.floor(4));
      var si2 = Math.floor(Math.random() * Math.floor(4));
      var si3 = Math.floor(Math.random() * Math.floor(4));
      var si4 = Math.floor(Math.random() * Math.floor(4));
      // console.log('sig ',sn,'si ',si1)
      var sig = this.signals_up.forEach((signal) => {
        if (signal.id % sn == 0) {
          signal.mi.setIcon(this.sigIcons[si1]);
        } else if (signal.id % 3 == 0) {
          signal.mi.setIcon(this.sigIcons[si2]);
        } else if (signal.id % 4 == 0) {
          signal.mi.setIcon(this.sigIcons[si3]);
        } else if (signal.id % 5 == 0) {
          signal.mi.setIcon(this.sigIcons[si4]);
        }
      });
      var sig_dn = this.signals_dn.forEach((signal) => {
        if (signal.id % sn == 0) {
          signal.mi.setIcon(this.dnSigIcons[si1]);
        } else if (signal.id % 3 == 0) {
          signal.mi.setIcon(this.dnSigIcons[si2]);
        } else if (signal.id % 4 == 0) {
          signal.mi.setIcon(this.dnSigIcons[si3]);
        } else if (signal.id % 5 == 0) {
          signal.mi.setIcon(this.dnSigIcons[si4]);
        }
      });
    },
    formatDate(date) {
      if (!date) return null;
      return moment(date).format("DD/MM/YYYY");
    },
    parseDate(date) {
      if (!date) return null;
      return moment(date, ["DD/MM/YYYY"]).format("YYYY-MM-DD");
    },
    queryTrain($event) {
      axios
        .get(`${process.env.VUE_APP_API_URL}/timetable/${$event}`)
        .then((response) => {
          console.log(response);
          if (response.data[0]) {
            this.valid = true;
            this.editItem.division = response.data[0].divn;
            this.editItem.zone = response.data[0].zone;
            this.editedItem.org = response.data[0].org;
            this.editedItem.dep = response.data[0].dep;
            this.editedItem.dest = response.data[0].dest;
            this.editedItem.arr = response.data[0].arr;
            this.editedItem.pf = response.data[0].pf;
            this.editedItem.next_train_no = response.data[0].next_train_no;
          } else {
            // this.valid =false
            this.editItem.division = null;
            this.editItem.zone = null;
            this.editedItem.org = null;
            this.editedItem.dep = null;
            this.editedItem.dest = null;
            this.editedItem.arr = null;
            this.editedItem.pf = null;
            this.editedItem.next_train_no = null;
          }
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.device_id = null;
        this.device_name = null;
        this.editedIndex = -1;
      }, 300);
    },
    //update traccar_db.device_train_map set dep = addtime(train_date, time(dep)), arr = addtime(train_date, time(arr));
    //update traccar_db.device_train_map set arr = adddate(arr, 1) where arr < dep;
    save() {
      var dep =
        moment(this.editedItem.train_date).format("YYYY-MM-DD") +
        " " +
        this.editedItem.dep;
      var arr =
        moment(this.editedItem.train_date).format("YYYY-MM-DD") +
        " " +
        this.editedItem.arr;
      if (moment(dep) > moment(arr)) {
        arr = moment(arr).add(1, "days").format("YYYY-MM-DD HH:mm:ss");
      }
      console.log(dep, arr);
      var update_time = moment()
        .tz("Asia/Kolkata")
        .format("YYYY-MM-DD HH:mm:ss");
      var train_device_map = {
        train_date: moment(this.editedItem.train_date).format("YYYY-MM-DD"),
        train_no: this.editedItem.train_no,
        zone: this.editItem.zone,
        division: this.editItem.division,
        device_id: this.device_id,
        device_name: this.device_name,
        unique_device_id: this.device_id,
        org: this.editedItem.org,
        dep: dep,
        dest: this.editedItem.dest,
        arr: arr,
        pf: this.editedItem.pf,
        next_train_no: this.editedItem.next_train_no,
        insert_time: update_time,
        update_time: update_time,
      };

      //console.log(train_device_map)
      axios.defaults.headers.common["Authorization"] =
        localStorage.getItem("jwtToken");

      axios
        .post(`${process.env.VUE_APP_API_URL}/train/`, train_device_map)
        .then((response) => {
          alert(`Train No ${train_device_map.train_no} added Succesfully`);
        })
        .catch((e) => {
          console.log(e);
          this.snackColor = "error";
          this.snackText = e.response.data.error;
          this.snack = true;
          this.errors.push(e);
        });

      this.close();
    },
    round(value, precision) {
      var multiplier = Math.pow(10, precision || 0);
      return Math.round(value * multiplier) / multiplier;
    },
    // getFormattedTime(t) {
    //   var lt = moment(t).format("YYYY-MM-DD HH:mm:ss")
    //   var testDateUtc = moment.utc(lt, ["YYYY-MM-DD HH:mm:ss"]);
    //   var localDate = moment(testDateUtc).local();
    //   return localDate.format("HH:mm")
    // },
    getShortTime(t) {
      //  return moment(t).tz('Asia/Kolkata').format("HH:mm")
      return moment.utc(t).format("HH:mm");
    },
    getLocalTime(t) {
      if (t) {
        // var lt = moment(t).format("YYYY-MM-DD HH:mm:ss")
        // var testDateUtc = moment.utc(lt);
        // var localDate = moment(testDateUtc).local();
        // return moment(localDate)
        return moment(t);
      }
    },
    getTimeFromNow(t) {
      if (t) {
        // var lt = moment(t).format("YYYY-MM-DD HH:mm:ss")
        // var testDateUtc = moment.utc(lt);
        // var localDate = moment(testDateUtc).local();
        // return moment(localDate).fromNow()
        return moment(t).fromNow();
      } else {
        return "Off Line";
      }
    },
    getFormattedTime(t) {
      if (t) {
        return moment(t).format("DD/MM/YYYY HH:mm:ss");
      } else {
        return "Off Line";
      }
      // var lt = moment(t).format("YYYY-MM-DD HH:mm:ss")
      // var testDateUtc = moment.utc(lt);
      // var localDate = moment(testDateUtc).local();
      // return localDate.format("HH:mm:ss")
    },
    startTime() {
      var today = new Date();
      var h = today.getHours();
      var m = today.getMinutes();
      var s = today.getSeconds();
      m = this.checkTime(m);
      s = this.checkTime(s);
      if (document.getElementById("info_text")) {
        document.getElementById("info_text").innerHTML =
          "<span style='font-size:20px;color:white'>" +
          h +
          ":" +
          m +
          ":" +
          s +
          "</span>";
      }
      // h + ":" + m + ":" + s;
      var t = setTimeout(this.startTime, 500);
    },
    checkTime(i) {
      if (i < 10) {
        i = "0" + i;
      } // add zero in front of numbers < 10
      return i;
    },
    SdahNh() {
      this.addSignal(SDAH_NH_SUB_SIG, this.sigIcon);
      //    this.addSignal(NH_SDAH_SUB_SIG,this.dnSigIcon);
    },
    onRowClick(device) {
      //  console.log(device)
      if (device.loc.latitude) {
        this.map.setView(
          {
            lat: device.loc.latitude,
            lng: device.loc.longitude,
          },
          20,
          {
            animation: true,
          }
        );
      }
    },
    prepareGioJson(section) {
      //   console.log(section)
      var sectionLines = {
        type: "FeatureCollection",
        features: [],
      };
      var dist = 0;
      for (var i = 0; i < section.length - 2; i++) {
        var sec = section[i];
        var sec_n = section[i + 1];
        dist = dist + JSON.parse(sec_n["attributes"])["distance"];
        var time = this.getFormattedTime(sec["fixtime"]);
        var speed = this.round(sec["speed"] * 1.852, 2);
        //    console.log(sec,sec_n)
        sectionLines.features.push({
          type: "Feature",
          geometry: {
            type: "LineString",
            coordinates: [
              [sec["longitude"], sec["latitude"]],
              [sec_n["longitude"], sec_n["latitude"]],
            ],
          },
          properties: {
            popupContent:
              speed +
              " KMPH" +
              ", " +
              time +
              ", " +
              this.round(dist / 1000, 3) +
              " KM",
            underConstruction: false,
            speed: speed,
          },
          id: i,
        });
      }
      return sectionLines;
    },

    round(value, precision) {
      var multiplier = Math.pow(10, precision || 0);
      return Math.round(value * multiplier) / multiplier;
    },
    saveSignals(section, section_name) {
      var signalCol = [];
      var stn_code = "";
      for (var i = 0; i < section.length; i++) {
        if (section[i][1].trim() === "") {
          stn_code = section[i][0].trim();
        }
        if (section[i][1].trim() != "") {
          signalCol.push({
            section: section_name,
            stn_code: stn_code,
            srl_no: i,
            description: section[i][0].trim(),
            km_no: section[i][1].trim(),
            left_right: section[i][2].trim(),
            lat: section[i][4],
            lng: section[i][3],
          });
        }
      }
      var p = {
        signals: signalCol,
      };
      axios.defaults.headers.common["Authorization"] =
        localStorage.getItem("jwtToken");

      axios
        .post(`${process.env.VUE_APP_API_URL}/geofences/save_signals`, p)
        .then((response) => {
          // clear the set post update call
          console.log(response);
        })
        .catch((e) => {
          console.log(e);
        });
    },

    prepareSigGioJson(section) {
      var signalFeatureCollection = {
        type: "FeatureCollection",
        features: [],
      };
      for (var i = 0; i < section.length; i++) {
        if (section[i][4] != null && section[i][3] != null) {
          signalFeatureCollection.features.push({
            type: "Feature",
            geometry: {
              type: "Point",
              coordinates: [section[i][4], section[i][3]],
            },
            properties: {
              popupContent: section[i][0] + "KM/No " + section[i][1],
              underConstruction: false,
            },
            id: i,
          });
        }
      }

      return signalFeatureCollection;
    },

    prepareSigGioJsonDB(section) {
      var signalFeatureCollection = {
        type: "FeatureCollection",
        features: [],
      };
      for (var i = 0; i < section.length; i++) {
        if (section[i].lat != null && section[i].lng != null) {
          signalFeatureCollection.features.push({
            type: "Feature",
            geometry: {
              type: "Point",
              coordinates: [section[i].lat, section[i].lng],
            },
            properties: {
              popupContent:
                section[i].description + "KM/No " + section[i].km_no,
              underConstruction: false,
            },
            id: section[i].id,
          });
        }
      }

      return signalFeatureCollection;
    },
    getColor(x) {
      if (this.selectRange) {
        return x < this.range[0]
          ? "#C0C0C0"
          : x > this.range[1]
          ? "#C0C0C0"
          : "#0000FF";
      }
      return x < 2
        ? "#FF0000"
        : x < 15
        ? "#FF7F00"
        : x < 40
        ? "#FFD700"
        : x < 60
        ? "#9ACD32"
        : x < 80
        ? "#00FF00"
        : x < 90
        ? "#008080"
        : "#FF00FF";
    },
    addSignal(section, signal_icon) {
      for (var i = 0; i < section.length; i++) {
        if (section[i][3] != null && section[i][4] != null) {
          var m = window.L.marker([section[i][3], section[i][4]], {
            icon: signal_icon,
            riseOnHover: true,
            draggable: true,
          })
            .addTo(this.map)
            .bindPopup(section[i][0] + "KM/No " + section[i][1])
            .openPopup();
          this.siganls.push({
            id: i,
            loc: [[section[i][3], section[i][4]]],
            title: section[i][0] + "KM/No " + section[i][1],
            icon: signal_icon,
            mi: m,
          });
        }
      }
    },
    onEachFeature(feature, layer) {
      if (feature.properties && feature.properties.popupContent) {
        layer.bindPopup(feature.properties.popupContent);
      }
    },
    showMarkers(sectionJson, sIcon, signals, fg) {
      return window.L.geoJson(sectionJson, {
        pointToLayer: function (feature, latlng) {
          var that = this;
          var m = window.L.marker(latlng, {
            icon: sIcon,
            riseOnHover: true,
            draggable: false,
          });
          signals.push({
            id: feature.id,
            loc: latlng,
            icon: sIcon,
            mi: m,
          });
          return m;
        },
        onEachFeature: function (feature, layer) {
          var popupContent = "<p>Sig: </p>";
          if (feature.properties && feature.properties.popupContent) {
            popupContent += feature.properties.popupContent;
          }
          layer.bindPopup(popupContent);
          layer.addTo(fg);
        },
      }).bindTooltip(
        function (layer) {
          return String(layer.feature.properties.popupContent); // Needs to be a string
        } //, {permanent: true, opacity: 0.5}
      );
    },
    onEachSigFeature(feature, layer) {
      var popupContent = "<p>Sig: </p>";
      if (feature.properties && feature.properties.popupContent) {
        popupContent += feature.properties.popupContent;
      }
      layer.bindPopup(popupContent);
    },
    addSectionToMap(section) {
      var that = this;
      window.L.geoJson(section, {
        onEachFeature: function (feature, layer) {
          if (feature.properties && feature.properties.popupContent) {
            layer.bindPopup(feature.properties.popupContent);
          }
        },
        style: function (feature) {
          return {
            color: that.getColor(feature.properties.speed),
            weight: 10,
            opacity: 0.85,
          };
        },
      })
        .bindTooltip(
          function (layer) {
            return String(layer.feature.properties.popupContent); // Needs to be a string
          } //, {permanent: true, opacity: 0.5}
        )
        .addTo(this.map);
    },
    onSwitch() {
      this.addSectionToMap(this.prepareGioJson(this.positions));
    },
    parseBeaconString(str, deviceTime) {
      // 11
      // 210025110405060708090a0b0c0d0e0f10020b010ab4
      // 210010110405060708090a0b0c0d0e0f10020b010ab7
      // 210025120405060708090a0b0c0d0e0f10020b010abd
      // console.log("210025110405060708090a0b0c0d0e0f10020b010ab4".length)
      var beaconlist = [];
      var str1 = str.substring(2); // exclude first 2 char
      var n = 0;
      var str2 = str1;
      while (str2.length > 0) {
        beaconlist.push({
          id: str1.substring(n + 2, n + 8),
          rssi: this.hexToDecm(str1.substring(n + 42, n + 44)),
          distance: this.round(
            this.calculateDistance(
              -69,
              this.hexToDecm(str1.substring(n + 42, n + 44))
            ),
            2
          ),
          devicetime: this.getFormattedTime(deviceTime),
        });
        n = n + 44;
        str2 = str1.substring(n);
        // console.log(str1.length,str2.length)
      }
      return beaconlist;
    },

    hexToDecm(h) {
      var a = "0x" + h;
      a = parseInt(a, 16);
      if ((a & 0x80) > 0) {
        a = a - 0x100;
      }
      return a;
    },

    calculateDistance(measuredPower, rssi) {
      if (rssi == 0) {
        return -1.0; // if we cannot determine distance, return -1.
      }
      var ratio = (rssi * 1.0) / measuredPower;
      if (ratio < 1.0) {
        return Math.pow(ratio, 10);
      } else {
        var distance = 0.89976 * Math.pow(ratio, 7.7095) + 0.111;
        return distance;
      }
    },
  },
};
</script>
<style>
.small {
  width: 100%;
  max-width: 1000px;
  margin: 10px auto;
}

.lc {
  background-color: PINK;
  border: 2px solid DARKORANGE;
}

.stn {
  font-size: 12px;
  font-style: bold;
  color: darkred;
  line-height: 8px;
}

.junction {
  font-size: 20px;
  font-style: normal;
  color: red;
  line-height: 16px;
  background-color: #3db2ff;
  border: 1px solid black;
  padding: 8px;
}

.leaflet-tooltip-left.lc::before {
  border-left-color: cyan;
}

.leaflet-tooltip-right.lc::before {
  border-right-color: cyan;
}

.transparentbackground {
  background: transparent;
  border: none;
}

.labelstyleemu_l {
  color: yellow;
  font-size: 12px;
  font-style: normal;
  line-height: 8px;
  /* height: 8px; */
  margin: 0px;
  padding: 2px;
  /* font-weight: 700; */
  /* background: transparent; */
  border: none;
  background-color: grey;
  /* border-color: red;
  border: 2px solid red; */
}
.labelstyledsl {
  color: yellow;
  font-size: 10px;
  font-style: normal;
  line-height: 8px;
  /* height: 8px; */
  margin: 0px;
  padding: 2px;
  /* font-weight: 700; */
  /* background: transparent; */
  border: none;
  background-color: #114e60;
  /* border-color: red;
  border: 2px solid red; */
}

.labelstyletvan {
  color: #8c0000;
  font-size: 10px;
  font-style: normal;
  line-height: 8px;
  /* height: 8px; */
  margin: 0px;
  padding: 2px;
  /* font-weight: 700; */
  /* background: transparent; */
  border: none;
  background-color: #3edbf0;
  /* border-color: red;
  border: 2px solid red; */
}

.labelstyleart {
  color: yellow;
  font-size: 10px;
  font-style: normal;
  line-height: 8px;
  /* height: 8px; */
  margin: 0px;
  padding: 2px;
  /* font-weight: 700; */
  /* background: transparent; */
  border: none;
  background-color: #ff0000;
  /* border-color: red;
  border: 2px solid red; */
}
.labelstylewam4 {
  color: red;
  font-size: 12px;
  font-style: normal;
  line-height: 8px;
  /* height: 8px; */
  margin: 0px;
  padding: 2px;
  /* font-weight: 700; */
  /* background: transparent; */
  border: none;
  background-color: #64dfdf;
  /* border-color: red;
  border: 2px solid red; */
}

.labelstylecar {
  color: yellow;
  font-size: 16px;
  font-style: normal;
  line-height: 10px;
  /* height: 8px; */
  margin: 0px;
  padding: 2px;
  /* font-weight: 700; */
  /* background: transparent; */
  border: none;
  background-color: #6a097d;
  /* border-color: red;
  border: 2px solid red; */
}

.labelstyleoffline {
  color: red;
  font-size: 20px;
  font-style: normal;
  line-height: 16px;
  /* height: 8px; */
  margin: 0px;
  padding: 2px;
  /* font-weight: 700; */
  /* background: transparent; */
  border: none;
  background-color: grey;
  /* border-color: red;
  border: 2px solid red; */
}

@keyframes fade {
  from {
    opacity: 0.5;
  }
}

.blinking {
  animation: fade 1s infinite alternate;
}
</style>
